import * as React from "react";
import { connect } from "react-redux";

import { RootState } from "../../state";
import { portfolioProjectsSelector } from "../selectors";
import { PortfolioProject } from "../entities";
import PortfolioSection from "./PortfolioSection";

interface OwnProps {
  editable?: boolean;
  locale: string;
}

interface MappedProps {
  projects: PortfolioProject[];
}

type Props = MappedProps & OwnProps;

const PortfolioSectionContainer: React.SFC<Props> = props => {
  const { projects, editable, locale } = props;
  return <PortfolioSection projects={projects} editable={editable} locale={locale} />;
};

function mapStateToProps(state: RootState): MappedProps {
  const projects = portfolioProjectsSelector(state);
  return { projects };
}

export default connect(mapStateToProps)(PortfolioSectionContainer);



// WEBPACK FOOTER //
// ./frontend/src/companies/components/PortfolioSectionContainer.tsx